/** A timestamp as Indian users read it, e.g. "10 Oct 2026, 3:45 pm". */
export const formatWhen = (iso: string) =>
  new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" });
